//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import ConfirmDeleteListModal from "../modals/confirm-delete-list-modal";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingListHeader",
  components: {
    InlinePrompt,
    SimpleButton,
    ConfirmDeleteListModal
  },
  props: {
    creating: {
      type: Boolean,
      default: true
    },
    listName: {
      type: String,
      default: ""
    },
    deletingList: {
      type: Object,
      default: () => ({})
    },
    creatingList: {
      type: Object,
      default: () => ({})
    },
    updatingList: {
      type: Object,
      default: () => ({})
    },
    backPath: {
      type: String,
      default: "/marketing/lists"
    },
    validator: {
      type: Object,
      default: null
    }
  },
  computed: {
    listTitle() {
      return this.creating ? this.$t("lists.createAList") : this.listName;
    }
  },
  methods: {
    handleDeleteList(modalRef) {
      this.$emit("delete-list", modalRef);
    },
    goBack() {
      const path = this.creating ? "/marketing/lists" : this.backPath;
      this.$router.replace({
        path
      });
    },
    showConfirmDeleteModal() {
      showBModal("confirm-delete-list-modal", {}, this);
    },
    handleSubmit() {
      if (this.validator.$invalid) return;
      this.$emit("submit");
    }
  }
});